import React, { useState } from "react";
import "./RedefinirSenha.css";
import { handleRedefinir, handleSolicitar } from "./functions";

import { Input } from "../../components/Input";
import SegurancaDeSenha from "../../components/SegurancaSenha/SegurancaSenha";
import { Loading } from "../../components/Loading";
import { Erro } from "../Cliente/AlteracaoSenha/AlteracaoSenha";
import { useNavigate } from "react-router";
import { AuthShell } from "../../components/AuthShell";

const RedefinirSenha = () => {
  const [novaSenha, setNovaSenha] = useState<string>("");
  const [confirmacaoSenha, setConfirmacaoSenha] = useState<string>("");
  const [erroForcaSenha] = useState<boolean>(false);
  const [sucesso, setSucesso] = useState<boolean>(false);
  const [falha, setFalha] = useState<boolean>(false);
  const [erro, setErro] = useState<Erro>({ erro: false, mensagem: "" });
  const [sucessoSolicitacao, setSucessoSolicitacao] = useState<boolean>(false);
  const [falhaSolicitacao, setFalhaSolicitacao] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

    const sender = urlParams.get("Sender");
    let email = urlParams.get("Email")!;
    let token = urlParams.get("Token")!;

    const navigate = useNavigate()

  return (
    <AuthShell
      eyebrow="Segurança Omex"
      title="Recupere seu acesso com segurança"
      subtitle="Crie uma nova senha para continuar protegendo suas operações e informações de conta."
      onLogoClick={() => navigate("/")}
    >
      {loading && <Loading />}
      <section className="auth-card reset-auth-card" aria-labelledby="reset-title">
        <div className="auth-card-header">
          <p className="auth-card-kicker">Nova credencial</p>
          <h2 className="auth-card-title" id="reset-title">Criar nova senha</h2>
          <p className="auth-card-copy">Escolha uma senha forte para finalizar a redefinição.</p>
        </div>

            {!sucesso && !falha ? (
              <form onSubmit={(e) => handleRedefinir(
                e,
                setErro,
                erro,
                novaSenha,
                confirmacaoSenha,
                erroForcaSenha,
                setLoading,
                email,
                sender,
                token,
                setSucesso,
                setFalha,
              )}>
                <div className="inputsNovaSenha">
                  <Input
                    className="form-control"
                    placeholder=" "
                    label="Digite a nova senha"
                    type={"password"}
                    value={novaSenha}
                    senha={true}
                    required
                    autoComplete="new-password"
                    onChange={(e: any) => {
                      setNovaSenha(e.target.value);
                    }}
                  />
                  <Input
                    className="form-control"
                    placeholder=" "
                    label="Confirme a nova senha"
                    type={"password"}
                    value={confirmacaoSenha}
                    senha={true}
                    required
                    autoComplete="new-password"
                    onChange={(e: any) => setConfirmacaoSenha(e.target.value)}
                  />
                </div>
                <SegurancaDeSenha senha={novaSenha} />
                {erro.erro && <p className="auth-message">{erro.mensagem}</p>}
                <button className="auth-primary-button reset-submit-button" type="submit">
                  Alterar
                </button>
              </form>
            ) : (
              <>
                {sucesso ? (
                  <div className="conteudo__div">
                    <p className="auth-message success">Senha alterada com sucesso.</p>
                    <button className="auth-inline-action" type="button" onClick={() => navigate('/')}>
                      Retornar ao login
                    </button>
                  </div>
                ) : (
                  <>
                    {!sucessoSolicitacao && !falhaSolicitacao ? (
                      <div className="conteudo__div">
                        <h5>Algo deu errado ao criar sua nova senha.</h5>
                        <p>
                          Clique a baixo para solicitar uma nova redefinição de
                          senha.
                        </p>
                        <button
                          className="auth-primary-button reset-submit-button"
                          type="button"
                          onClick={() => handleSolicitar(
                            setLoading,
                            setSucessoSolicitacao,
                            setFalhaSolicitacao,
                            sender,
                            email
                          )}
                        >
                          Solicitar novo link
                        </button>
                      </div>
                    ) : (
                      <>
                        {sucessoSolicitacao ? (
                          <div className="conteudo__div">
                            <h5>
                              Uma nova solicitação de redefinição de senha foi
                              enviada ao seu email.
                            </h5>
                          </div>
                        ) : (
                          <div className="conteudo__div">
                            <h5>Algo deu errado na sua solicitação.</h5>
                            <p>Clique a baixo para tentar novamente.</p>
                            <button
                              className="auth-primary-button reset-submit-button"
                              type="button"
                              onClick={() => handleSolicitar(
                                setLoading,
                                setSucessoSolicitacao,
                                setFalhaSolicitacao,
                                sender,
                                email
                              )}
                            >
                              Tentar novamente
                            </button>
                          </div>
                        )}
                      </>
                    )}
                  </>
                )}
              </>
            )}
      </section>
    </AuthShell>
  );
};

export default RedefinirSenha;
